<template>
  <div class="ContentTabs__container">
    <h2 class="SubPage__subHeading">{{ config.title }}</h2>
    <div v-if="!isMobile" class="ContentTabs__tabs">
      <a
        v-for="(tab, index) in config.tabs.length"
        :key="`${index}-aKey`"
        v-on:click="updateTabs(tab)"
        :class="[
          'ContentTabs__tab',
          { ContentTabs__active: activeTab === tab },
          { ContentTabs__disabled: config.tabs[index].disabled }
        ]"
      >
        {{ config.tabs[index].title }}
      </a>
      <div
        :class="[
          'ContentTabs__content',
          { ContentTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, index) in config.tabs.length"
        :key="`${index}-bKey`"
      >
        <template v-if="activeTab === tab">
          <NewsletterSubscribe
            v-if="tab === 1"
            :config="config.tabs[index].formConfig"
          />
          <NewsletterUnsubscribe
            v-if="tab === 2"
            :config="config.tabs[index].formConfig"
          />
        </template>
      </div>
    </div>
    <div v-if="isMobile" class="ContentTabs__tabs ContentTabs__mobile">
      <div v-for="(tab, index) in config.tabs.length" :key="`${index}-cKey`">
        <a
          v-if="!config.tabs[index].disabled"
          v-on:click="updateTabs(tab)"
          :class="[
            'ContentTabs__tab',
            { ContentTabs__active: activeTab === tab && mobileHidden !== tab }
          ]"
        >
          {{ config.tabs[index].title }}
        </a>
        <div
          :class="[
            'ContentTabs__content',
            { ContentTabs__activeContent: activeTab === tab && !isMobile },
            {
              ContentTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <template v-if="activeTab === tab">
            <NewsletterSubscribe
              v-if="tab === 1"
              :config="config.tabs[index].formConfig"
            />
            <NewsletterUnsubscribe
              v-if="tab === 2"
              :config="config.tabs[index].formConfig"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsletterSubscribe from "./NewsletterSubscribe";
import NewsletterUnsubscribe from "./NewsletterUnsubscribe";

export default {
  name: "NewsletterForm",
  components: {
    NewsletterSubscribe,
    NewsletterUnsubscribe
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isMobile: false,
      activeTab: null,
      mobileHidden: null,
      activeTabPreselected: false
    };
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    initTabs() {
      for (const [index, tab] of this.config.tabs.entries()) {
        if (tab.active && !tab.disabled) {
          this.activeTab = index + 1;
          this.activeTabPreselected = true;
        }
      }
      if (!this.activeTabPreselected) {
        this.activeTab = 1;
      }
    },
    updateTabs(tab) {
      const elm = event.currentTarget;
      if (!elm.classList.contains("ContentTabs__disabled")) {
        if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab !== this.mobileHidden
        ) {
          this.mobileHidden = tab;
        } else if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab === this.mobileHidden
        ) {
          this.mobileHidden = null;
        } else if (this.isMobile && this.activeTab !== tab) {
          this.mobileHidden = null;
          this.activeTab = tab;
        } else {
          this.activeTab = tab;
        }
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
    this.initTabs();
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>
